import { createFileRoute } from '@tanstack/react-router';
import { useSessionStore } from '@/store/sessionStore';
import { ProfileSettings } from '../../-components/ProfileSettings';

export const Route = createFileRoute('/(client)/profile/(pages)/settings/')({
  component: SettingsPage,
});

function SettingsPage() {
  const user = useSessionStore(s => s.user);
  if (!user) return null;
  return <ProfileSettings user={user} />;
}
